import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

// Prepend current lang prefix to internal paths. External / mailto / tel / hash stay as-is.
const prefixPath = (to, prefix) => {
  if (typeof to !== "string") return to;
  if (
    to.startsWith("http") ||
    to.startsWith("mailto:") ||
    to.startsWith("tel:") ||
    to.startsWith("#")
  ) {
    return to;
  }
  if (!to.startsWith("/")) return to;
  if (!prefix) return to;
  if (to === "/") return prefix || "/";
  return `${prefix}${to}`;
};

export const LLink = React.forwardRef(({ to, ...rest }, ref) => {
  const { prefix } = useLang();
  return <Link ref={ref} to={prefixPath(to, prefix)} {...rest} />;
});
LLink.displayName = "LLink";

export const LNavLink = React.forwardRef(({ to, ...rest }, ref) => {
  const { prefix } = useLang();
  return <NavLink ref={ref} to={prefixPath(to, prefix)} {...rest} />;
});
LNavLink.displayName = "LNavLink";

export default LLink;
